import React, { memo } from "react";
import { Button } from "primereact/button";

function bionicText(text) {
  return text.split(" ").map((word, index) => {
    if (!word) return " ";
    const mid = Math.ceil(word.length / 2);
    return (
      <>
        <b key={index * Math.random() + "-bionic"}>{word.slice(0, mid)}</b>
        {word.slice(mid)}{" "}
      </>
    );
  });
}

const SignInButton = memo(
  ({ isLoading, accessError, handleGoogleSignIn, bionicEnabled }) => (
    <div className="sign-in-container">
      <h2>{bionicEnabled ? bionicText("Let's Get Started") : "Let's Get Started"}</h2>
      <Button
        label={isLoading ? "Checking Access..." : "Join us"}
        icon="pi pi-google"
        iconPos="right"
        onClick={handleGoogleSignIn}
        loading={isLoading}
        disabled={isLoading || !!accessError}
        className="sign-in-button"
      />
    </div>
  )
);

export default SignInButton;
